import React from 'react';

const SOURCE_LABELS = { borrower_portal: 'the borrower portal', docusign: 'a signed DocuSign envelope' };

// Read-only: staff cannot record e-consent. The server sets it when the borrower
// accepts the consent screen or a completed DocuSign envelope comes back.
export function EconsentStatus({ borrower, testId = 'bi-econsent' }) {
  const b = borrower || {};
  if (!b.econsent) {
    return (
      <div className="text-[12px] text-slate-500" data-testid={testId}>
        <span className="font-semibold text-slate-600">eConsent: not received.</span>{' '}
        Recorded when the borrower accepts the consent screen or a signed DocuSign envelope comes back.
      </div>
    );
  }
  const when = b.econsent_at && !Number.isNaN(Date.parse(b.econsent_at))
    ? new Date(b.econsent_at).toLocaleString()
    : null;
  return (
    <div className="text-[12px] text-slate-600" data-testid={testId}>
      <span className="font-semibold" style={{ color: '#6BA82E' }}>eConsent received</span>
      {when ? ` ${when}` : ''}
      {SOURCE_LABELS[b.econsent_source] ? ` through ${SOURCE_LABELS[b.econsent_source]}` : ''}
      {b.econsent_ip ? ` (IP ${b.econsent_ip})` : ''}
    </div>
  );
}
